import { createApi } from '@reduxjs/toolkit/query/react';

import { API_CONSTANTS } from '../../../utils/constants';
import { baseQueryWithReauth } from '../../../apis/baseQuery';
import { ApiResponse, ListResponse } from '../../../model';

export const systemEmailApi = createApi({
  reducerPath: 'systemEmailApi',
  baseQuery: baseQueryWithReauth,
  endpoints: (build) => ({
    emailList: build.query<ListResponse<any>, unknown>({
      query: (body: unknown) => ({
        url: API_CONSTANTS.EMAIL.SYSTEM_EMAIL_LIST_URL,
        method: 'POST',
        body,
      }),
    }),
    addEmail: build.mutation<ApiResponse<any>, unknown>({
      query: (body: unknown) => ({
        url: API_CONSTANTS.EMAIL.ADD_SYSTEM_EMAIL_URL,
        method: 'POST',
        body,
      }),
    }),
    getSingleEmail: build.query<ApiResponse<any>, string | number>({
      query: (id: string | number) => ({
        url: API_CONSTANTS.EMAIL.GET_SINGLE_EMAIL_URL(id),
        method: 'GET',
      }),
    }),
    updateEmail: build.mutation<
      ApiResponse<any>,
      { id: string | number; obj: any }
    >({
      query: (body) => ({
        url: API_CONSTANTS.EMAIL.UPDATE_EMAIL_URL(body.id),
        method: 'PUT',
        body: body.obj,
      }),
    }),
  }),
});

export const {
  useEmailListQuery,
  useAddEmailMutation,
  useLazyGetSingleEmailQuery,
  useUpdateEmailMutation,
} = systemEmailApi;
